module.exports = __webpack_public_path__ + "img/paypal.b52ad516.svg";